import React from 'react'
import { spacingClassNames } from 'utils'
import StoresMap from 'components/StoresMap'
import { injectIntl, WrappedComponentProps } from 'react-intl'

import getConstants from '../../constants'

import StoreInfo from './components/StoreInfo'
import { DistanceUnit } from 'typings'
import {
  HeaderPage,
  LinkText,
  TemplateStoreLocator,
  GutterContainer,
} from 'shared-global-ec-uikit/components/dist/react/esm'
import Parser from 'html-react-parser'

const CONSTANTS = getConstants()

const GOOGLE_MAPS_API_KEY = CONSTANTS.GOOGLE_MAPS_API_KEY

type Props = {
  storeDetails: Components.Schemas.StoreDetail
  isMapVisible?: boolean
} & WrappedComponentProps

const StoreDetails = ({ intl, storeDetails, isMapVisible = true }: Props) => {
  const storeList = storeDetails.id ? [storeDetails] : []

  return (
    <>
      {storeDetails ? (
        <TemplateStoreLocator
          map={
            <div className="fr-ec-mt-spacing-05">
              <StoresMap
                className={`map-container ${spacingClassNames({
                  sm: 6,
                  md: 6,
                })}`}
                apiKey={GOOGLE_MAPS_API_KEY}
                initialCenter={{
                  latitude: Number(storeDetails.latitude),
                  longitude: Number(storeDetails.longitude),
                }}
                dimensions={{ width: '100%', height: 326 }}
                initialZoom={
                  CONSTANTS.GEO_COORDINATES.INITIAL_ZOOM_DETAILS_PAGE
                }
                storeList={storeList}
                intlMessages={{
                  searchThisArea: intl.formatMessage({
                    id: 'text_search_this_area',
                  }),
                  getDirections: intl.formatMessage({
                    id: 'text_showdirection',
                  }),
                  distanceAway:
                    CONSTANTS.DISTANCE_UNIT === DistanceUnit.MILE
                      ? intl.formatMessage({ id: 'text_mile' })
                      : intl.formatMessage({ id: 'text_km' }),
                }}
              />
              {storeList[0].comment2 && (
                <GutterContainer>
                  <LinkText
                    href={Parser(storeList[0].comment2)}
                    emphasize={false}
                    element="a"
                    target="_blank"
                    className="fr-ec-mb-spacing-02"
                  >
                    {intl.formatMessage({
                      id: 'text_store_locator_opening_fliyer_link',
                    })}
                  </LinkText>
                </GutterContainer>
              )}
            </div>
          }
          searchResult={<StoreInfo storeInfo={storeDetails} />}
          pageHeading={
            <>
              <HeaderPage title={storeDetails.name} labelElement="h1" />
            </>
          }
          toggleMinHeight
        />
      ) : null}
    </>
  )
}

export default injectIntl(StoreDetails)
